import type { Schema as MetaSchema } from "./meta";
import type { Schema as OptionsSchema } from "./options";

function getNumberOfSkippedItems({ number, size }: OptionsSchema) {
  return (number - 1) * size;
}

function getLastPageNumber({ size, totalItems }: Pick<MetaSchema, "size" | "totalItems">) {
  return Math.ceil(totalItems / size);
}

export { getLastPageNumber, getNumberOfSkippedItems };
